import React from "react";

export const MGSupportResult = ({ result, formatCurrency, calcPercent }) => {
  const support = result.sale_category === "SOCIETE" ? result.company_aid :
    result.sale_category === "VD" ? result.vd_aid : result.systematic_prime;
  const rows = [
    ["base", "Marge de base", result.base_margin],
    ["support", `Support MG ${result.mg_support_category}${result.mg_b2b01_tier ? ` · Palier ${result.mg_b2b01_tier}` : ""}${result.sale_category === "VD" ? " · VD" : ""}`, support],
    ...(result.mg_quality_prime_ht > 0 ? [["quality", "Prime qualité garantie", result.mg_quality_prime_ht]] : []),
    ...(result.prime_fidelite > 0 ? [["loyalty", "Prime fidélité", result.prime_fidelite]] : []),
    ...(result.exceptional_aid > 0 ? [["exceptional", "Aide exceptionnelle", result.exceptional_aid]] : []),
  ];
  return rows.map(([key, label, amount]) => (
    <div key={key} data-testid={`mg-result-${key}-row`} className="flex flex-wrap justify-between gap-x-3 gap-y-1">
      <span>{label}</span>
      <span data-testid={`mg-result-${key}-amount`} className="font-data">
        {formatCurrency(amount)} <span data-testid={`mg-result-${key}-rate`} className="text-muted-foreground text-xs">
          {key === "quality" ? `(${Number(result.mg_quality_prime_rate * 100).toLocaleString("fr-FR")} % du prix HT)` : calcPercent(amount)}
        </span>
      </span>
    </div>
  ));
};